import { render, staticRenderFns } from "./boardLog.vue?vue&type=template&id=082ce93e&scoped=true"
import script from "./boardLog.vue?vue&type=script&lang=js"
export * from "./boardLog.vue?vue&type=script&lang=js"
import style0 from "./boardLog.vue?vue&type=style&index=0&id=082ce93e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082ce93e",
  null
  
)

export default component.exports